<div class="error-page">
    <div data-cy="error-image" class="error-page_image {{pageInformation.icon}}"></div>
    <h1 class="error-page_title" data-cy="error-title">{{pageInformation.title}}</h1>
    <h2 class="error-page_subtitle" data-cy="error-subtitle">{{pageInformation.subtitle}}</h2>
</div>
